import React from 'react'

const Menus: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-gray-900">Menus</h1>
      <p className="text-gray-600 mt-2">Página em desenvolvimento</p>
    </div>
  )
}

export default Menus



